import {
  BaSeDialogContext,
  BaSeParagraph,
  BaSeShapeButton,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { WrapperShared } from './card-styled';

export const ModalShared = ({ shareData, closeModal }) => {
  const { showNotification } = React.useContext(BaSeDialogContext);
  const { azulSebrae36, cinzaSebrae45 } = BaSeTheme.colors.institucionais;
  const { azulSebrae63 } = BaSeTheme.colors.brandbook;
  const { turquesa25, pessoas } = BaSeTheme.colors.gestao;
  const {text, url} = shareData;
  const urlApp = encodeURIComponent(url);

  const apps = React.useMemo(
    () => [
      {
        name: 'whatsapp',
        nameIcon: 'logos/whatsapp-fill',
        color: turquesa25,
        link: `https://wa.me/?text=${text} ${urlApp}`,
      },
      {
        name: 'telegram',
        nameIcon: 'telegram',
        color: azulSebrae63,
        link: `https://t.me/share/url?url=${urlApp}&text=${text}`,
      },
      {
        name: 'gmail',
        nameIcon: 'logos/google-fill',
        color: pessoas,
        link: `https://mail.google.com/mail/?view=cm&su=Compartilhar&body=${text} ${urlApp}`,
      },
      {
        name: 'facebook',
        nameIcon: 'facebook',
        color: azulSebrae36,
        link: `https://www.facebook.com/sharer/sharer.php?u=${urlApp}`,
      },
      {
        name: 'link',
        nameIcon: 'link',
        color: azulSebrae36,
        link: null,
      },
    ],
    [azulSebrae36, azulSebrae63, pessoas, text, turquesa25, urlApp],
  );

  const copyLink = React.useCallback(() => {
    navigator.clipboard
      .writeText(url)
      .then(() =>
        showNotification({
          message: 'Link copiado com sucesso!',
          color: 'confirmation',
        }),
      )
      .catch(() =>
        showNotification({
          message: 'Erro ao copiar o link',
          color: 'destructive',
        }),
      )
      .finally(() => closeModal());
  }, [closeModal, showNotification, url]);

  const shareLink = React.useCallback(
    (app, link) => {
      if (app === 'link') {
        copyLink();
        return;
      }

      window.open(link, '_blank');
      closeModal();
    },
    [closeModal, copyLink],
  );

  return (
    <>
      <BaSeParagraph color={cinzaSebrae45}>
        Como deseja compartilhar o certificado?
      </BaSeParagraph>
      <WrapperShared>
        {apps?.map((app, i) => (
          <BaSeShapeButton
            key={i}
            buttonType="button"
            color={app.color}
            nameIcon={app.nameIcon}
            onClick={() => shareLink(app.name, app.link)}
            shape="circle"
            size="big"
            sizeIcon="big"
            type="tertiary"
            tooltip={
              !app.link && {
                direction: 'bottom',
                message: 'Copiar link',
                size: 'small',
                width: 70,
              }
            }
          />
        ))}
      </WrapperShared>
    </>
  );
};
